import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

function BackToTopButton() {
  const [backToTopButton, setBackToTopButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setBackToTopButton(true);
      } else {
        setBackToTopButton(false);
      }
    });
  });

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {backToTopButton && (
        <button
          style={{
            position: "fixed",
            bottom: "20px",
            right: "15px",
            height: "40px",
            width: "40px",
            fontSize: "25px",
            borderRadius: "50%",
          }}
          onClick={scrollUp}
        >
          <FaArrowUp />
        </button>
      )}
    </div>
  );
}

export default BackToTopButton;
